<div class="row">
  <div class="col-lg-1"></div>
  <div class="col-lg-10">
    <div class="row">
      <!-- Order Confirmation -->
      <div style="display: flex; flex-direction: column; justify-content: center; align-items: center; height: 40vh; margin-bottom: 10px;">
        <img src="assets/images/success.png" alt="Order Success" style="width: 100px; height: auto; margin-bottom: 10px;">
        <div class="text-center">
          <h4 class="mb-1 fw-bold">Order Placed, Thank You!</h4>
          <p class="mb-1 fs-5">Order ID {{ idParam }}</p>
          <p class="mb-1">Confirmation mail will be sent to your email in next 30 seconds.</p>
          <!-- <p class="mb-1 fw-bold">Congrats! You have earned 50 Points on this purchase</p> -->
        </div>
      </div>

      <!-- Feedback Loading Spinner -->
      <ng-container *ngIf="isLoadingFeedback && showFeedbackForm">
        <div class="col-lg-12 text-center py-5">
          <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
          <p class="mt-3">Loading feedback form...</p>
        </div>
      </ng-container>

      <!-- Feedback Form -->
      <ng-container *ngIf="showFeedbackForm && !isLoadingFeedback">
        <hr>
        <div class="col-lg-2"></div>
        <div class="col-lg-8">
          <div class="card">
            <div class="card-header align-items-center d-flex" style="border-radius: 20px;">
              <h4 class="card-title mb-0 flex-grow-1">Help us improve! Take our quick rating survey.</h4>
            </div>
            <div class="card-body">
              <div class="live-preview">
                <div class="table-responsive">
                  <table class="table align-middle mb-0">
                    <tbody>
                      <tr *ngFor="let question of questions; let qIdx = index">
                        <td>
                          <p class="mb-1">{{ qIdx + 1 }}. {{ question }}</p>
                          <div class="custom-rating d-flex justify-content-between text-center" style="max-width: 100%; margin: auto;">
                          <ng-container *ngFor="let label of labels; let i = index">
                            <div class="star-item flex-fill" (click)="selectRating(qIdx, i + 1)" style="cursor: pointer;">
                              <span class="custom-star"
                                    [class.filled]="defaultSelects[qIdx] > i"
                                    style="font-size: 30px;">
                                &#9733;
                              </span>
                              <div class="star-label mt-1" style="font-size: 13px;">{{ label }}</div>
                            </div>
                          </ng-container>
                        </div>
                          <ng-template #starTemplate let-fill="fill">
                            <span class="custom-star" [class.filled]="fill === 100">&#9733;</span>
                          </ng-template>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div class="d-flex justify-content-start mt-4 gap-3">
                  <button class="btn btn-primary rounded-pill px-5 py-2" (click)="submitFeedback()" [disabled]="isSubmitting">
                    <span *ngIf="!isSubmitting">Submit</span>
                    <span *ngIf="isSubmitting" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                    <span *ngIf="isSubmitting">Submitting...</span>
                  </button>
                  <button class="btn btn-outline-secondary rounded-pill px-5 py-2" (click)="cancelFeedback()" [disabled]="isSubmitting">Cancel</button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-2"></div>
      </ng-container>

      <!-- Feedback Success Message -->
      <ng-container *ngIf="feedbackSubmitted">
        <hr>
        <div class="col-lg-2"></div>
        <div class="col-lg-8 mt-4">
          <div class="p-4" style="background-color: #e6f7ed; border-radius: 10px;">
            <div class="row align-items-center">
              <!-- Text (Left) -->
              <div class="col-md-7 text-start">
                <h5 class="fw-bold mb-0 text-success" style="font-size: 25px; line-height: 1.5; color: #28a745;">
                  Thank you for sharing your feedback with us.
                </h5>
              </div>
              <!-- Image (Right) -->
              <div class="col-md-5 text-end">
                <img src="assets/images/feedback-success.png" alt="Feedback Success" style="width: 238px; height: auto;">
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-2"></div>
      </ng-container>



    </div>
  </div>
  <div class="col-lg-1"></div>
</div>
